import { useCallback, useMemo, useState } from "react";

import type { TransientConfigurationFormState, TransientConfigurationPayload } from "../model/transientConfiguration";

import { buildTransientConfigurationPayload, DEFAULT_TRANSIENT_CONFIGURATION } from "../model/transientConfiguration";

export const useTransientConfiguration = () => {
  const [configuration, setConfiguration] = useState<TransientConfigurationFormState>(DEFAULT_TRANSIENT_CONFIGURATION);

  const updateConfiguration = useCallback(
    <K extends keyof TransientConfigurationFormState>(key: K, value: TransientConfigurationFormState[K]) => {
      setConfiguration((current) => ({ ...current, [key]: value }));
    },
    []
  );

  const reset = useCallback((selectedScenarioIds: number[] = []) => {
    setConfiguration({ ...DEFAULT_TRANSIENT_CONFIGURATION, scenarios: selectedScenarioIds });
  }, []);

  const replace = useCallback((next: TransientConfigurationFormState) => {
    setConfiguration(next);
  }, []);

  const getPayload = useCallback(
    (): TransientConfigurationPayload => buildTransientConfigurationPayload(configuration),
    [configuration]
  );

  return useMemo(
    () => ({
      configuration,
      getPayload,
      replace,
      reset,
      updateConfiguration,
    }),
    [configuration, getPayload, replace, reset, updateConfiguration]
  );
};

export type UseTransientConfigurationReturn = ReturnType<typeof useTransientConfiguration>;
